/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IntranetPortal_UserProfiles_Dtos_UserProfileDto } from '../models/IntranetPortal_UserProfiles_Dtos_UserProfileDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserProfileService {

    /**
     * @returns IntranetPortal_UserProfiles_Dtos_UserProfileDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppUserProfileUserProfile(): CancelablePromise<Array<IntranetPortal_UserProfiles_Dtos_UserProfileDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/user-profile/user-profile',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @param id
     * @returns IntranetPortal_UserProfiles_Dtos_UserProfileDto Success
     * @throws ApiError
     */
    public static getCoreApiApiAppUserProfileUserProfileById(
        id: string,
    ): CancelablePromise<IntranetPortal_UserProfiles_Dtos_UserProfileDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/core-api/api/app/user-profile/{id}/user-profile-by-id',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

    /**
     * @param id
     * @param activate
     * @returns boolean Success
     * @throws ApiError
     */
    public static postCoreApiApiAppUserProfileToggleUserActivationStatus(
        id: string,
        activate?: boolean,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/core-api/api/app/user-profile/{id}/toggle-user-activation-status',
            path: {
                'id': id,
            },
            query: {
                'activate': activate,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Server Error`,
                501: `Server Error`,
            },
        });
    }

}
